import { checkSupportsInterface, encrypt } from '../core';
import { v5SupportInterfaceIds, v5Contracts } from '../token-registry-v5';
import { v4SupportInterfaceIds, v4Contracts } from '../token-registry-v4';
import { getTxOptions } from './utils';
import { getEthersContractFromProvider, isV6EthersProvider } from '../utils/ethers';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const mint = /* @__PURE__ */ __name(async (contractOptions, signer, params, options) => {
  const { tokenRegistryAddress } = contractOptions;
  const { chainId, maxFeePerGas, maxPriorityFeePerGas, titleEscrowVersion } = options;
  if (!tokenRegistryAddress) throw new Error("Token registry address is required");
  if (!signer.provider) throw new Error("Provider is required");
  const { beneficiaryAddress, holderAddress, tokenId, remarks } = params;
  let isV5TT = titleEscrowVersion === "v5";
  let isV4TT = titleEscrowVersion === "v4";
  if (titleEscrowVersion === void 0) {
    [isV4TT, isV5TT] = await Promise.all([
      checkSupportsInterface(
        tokenRegistryAddress,
        v4SupportInterfaceIds.TradeTrustTokenMintable,
        signer.provider
      ),
      checkSupportsInterface(
        tokenRegistryAddress,
        v5SupportInterfaceIds.TradeTrustTokenMintable,
        signer.provider
      )
    ]);
  }
  if (!isV4TT && !isV5TT) {
    throw new Error("Only Token Registry V4/V5 is supported");
  }
  const Contract = getEthersContractFromProvider(signer.provider);
  let tradeTrustTokenContract;
  if (isV5TT) {
    tradeTrustTokenContract = new Contract(
      tokenRegistryAddress,
      v5Contracts.TradeTrustToken__factory.abi,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      signer
    );
  } else if (isV4TT) {
    tradeTrustTokenContract = new Contract(
      tokenRegistryAddress,
      v4Contracts.TradeTrustToken__factory.abi,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      signer
    );
  }
  const encryptedRemarks = remarks && isV5TT ? `0x${encrypt(remarks, options.id ?? "")}` : "0x";
  try {
    const isV6 = isV6EthersProvider(signer.provider);
    const args = isV5TT ? [beneficiaryAddress, holderAddress, tokenId, encryptedRemarks] : [beneficiaryAddress, holderAddress, tokenId];
    if (isV6) {
      await tradeTrustTokenContract.mint.staticCall(...args);
    } else {
      await tradeTrustTokenContract.callStatic.mint(...args);
    }
  } catch (e) {
    console.error("callStatic failed:", e);
    throw new Error("Pre-check (callStatic) for mint failed");
  }
  const txOptions = await getTxOptions(
    signer,
    chainId,
    maxFeePerGas,
    maxPriorityFeePerGas
  );
  if (isV5TT) {
    return await tradeTrustTokenContract.mint(
      beneficiaryAddress,
      holderAddress,
      tokenId,
      encryptedRemarks,
      txOptions
    );
  } else if (isV4TT) {
    return await tradeTrustTokenContract.mint(
      beneficiaryAddress,
      holderAddress,
      tokenId,
      txOptions
    );
  }
}, "mint");

export { mint };
